// One extended-description block with En / Ru / Қазақша (kk optional).
const LANGS = [
  { code: "en", label: "English" },
  { code: "ru", label: "Русский" },
  { code: "kk", label: "Қазақша (необязательно)" },
];

const INPUT_CLS =
  "mt-1 w-full rounded-md border-0 py-1.5 px-4 text-neutral-900 ring-1 ring-inset ring-neutral-300 placeholder:text-neutral-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6";

export default function DescriptionInputs({
  index,
  desc,
  onNameChange,
  onDescChange,
  onHighlightChange,
}) {
  return (
    <div className="w-full border-b-2 border-neutral-300 pb-4">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-2">
        <div className="block text-sm font-medium text-neutral-700">
          {`Описание № ${index + 1}`}
        </div>
        {/* Выделенный блок клиент видит золотой рамкой со звездой */}
        <label className="flex items-center gap-2 cursor-pointer select-none">
          <input
            type="checkbox"
            checked={Boolean(desc?.highlight)}
            onChange={(e) => onHighlightChange(index, e.target.checked)}
            className="h-4 w-4 rounded border-neutral-300 text-amber-500 focus:ring-amber-400"
          />
          <span className="text-sm text-neutral-600">
            Хайлайт <span className="text-neutral-400">— выделить у клиента</span>
          </span>
        </label>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        {LANGS.map((l) => (
          <div key={l.code}>
            <span className="block text-xs text-neutral-400 mb-0.5">
              {l.label}
            </span>
            <input
              type="text"
              className={INPUT_CLS}
              placeholder="Заголовок"
              value={desc?.name?.[l.code] || ""}
              onChange={(e) => onNameChange(index, e.target.value, l.code)}
            />
            <textarea
              className={`${INPUT_CLS} mt-2`}
              placeholder="Текст"
              value={desc?.description?.[l.code] || ""}
              onChange={(e) => onDescChange(index, e.target.value, l.code)}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
